// reacttour/TourStyles.js

const isMobile = () => window.innerWidth <= 640;

export const tourStyles = {
  popover: (base) => ({
    ...base,
    borderRadius: isMobile() ? 16 : 12,
    padding: isMobile() ? "16px 18px" : "20px 24px",
    boxShadow: isMobile()
      ? "0 -2px 24px rgba(0,0,0,0.18)"
      : "0 4px 20px rgba(0,0,0,0.15)",
    backgroundColor: "#ffffff",
    color: "#333",
    maxWidth: isMobile() ? "min(92vw, 400px)" : 320,
    width: isMobile() ? "min(92vw, 400px)" : undefined,
    boxSizing: "border-box",
  }),

  maskArea: (base) => ({
    ...base,
    rx: 10,
    ry: 10,
  }),

  maskWrapper: (base) => ({
    ...base,
    color: "rgba(0, 0, 0, 0.55)", // background dimming
  }),

  badge: (base) => ({
    ...base,
    background: "#1f6b4f", // brand green (styles/theme.js colors.primary)
    color: "#fff",
    fontSize: "12px",
    fontWeight: "600",
  }),

  controls: (base) => ({
    ...base,
    marginTop: 20,
  }),

  control: (base) => ({
    ...base,
    borderRadius: 8,
    padding: "6px 12px",
    border: "1px solid #dcdcdc",
    background: "#fff",
    color: "#333",
    fontWeight: 500,
    cursor: "pointer",
  }),

  arrow: (base) => ({
    ...base,
    color: "#fff",
  }),

  highlightedArea: (base) => ({
    ...base,
    outline: "2px solid #1f6b4f", // highlight box around active element
    outlineOffset: 4,
    borderRadius: 12,
  }),
};
